import * as React from 'react';

/** Viewport below this width uses top bar + drawer instead of fixed sidebar. */
export const NAV_COMPACT_BREAKPOINT = 1250;

export function useNavCompact() {
  const [isNavCompact, setIsNavCompact] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${NAV_COMPACT_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsNavCompact(window.innerWidth < NAV_COMPACT_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    onChange();
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isNavCompact;
}
